export enum EnergyLabels {
  None = 'None',
  G = 'G',
  F = 'F',
  E = 'E',
  D = 'D',
  C = 'C',
  B = 'B',
  A = 'A',
  A1plus = 'A1plus',
  A2plus = 'A2plus',
  A3plus = 'A3plus',
  A4plus = 'A4plus',
  A4plusEPG = 'A4plusEPG'
}

export const EnergyLabelsDiscounts: Record<string, number> = {
  B: 0.1,
  A: 0.15
};

export enum FutureEnergyLabel {
  B = 'B',
  A = 'A',
  C_OR_LOWER = 'C_OR_LOWER'
}
